// Retour en haut partagé par les wizards loan (devis et adhésion)
// setTimeout et non requestAnimationFrame : Chrome gèle les rAF d'un onglet en arrière-plan, le scroll ne partirait jamais
// Différé : les écrans restent tous montés, le scroll doit attendre que `hidden` ait rendu le document à sa nouvelle hauteur
// Scroll instantané : un 'smooth' lancé avant ce relayout est annulé, la page reste en bas sur mobile
export const scrollWizardToTop = () => {
    setTimeout(() => window.scrollTo({ top: 0, left: 0 }), 0)
}
